import { Card, Col, Row } from "react-bootstrap";
import { CgCommunity } from "react-icons/cg";
import { PiCircleHalfLight } from "react-icons/pi";
import { FaCircleDollarToSlot, FaBitcoin } from "react-icons/fa6";
import { BsCurrencyBitcoin } from "react-icons/bs";
import { MdOutlineSocialDistance } from "react-icons/md";

const FeaturesCards = () => {
  return (
    <Row className="my-3 justify-content-center">
      {/* Card 1 */}
      <Col md={6} lg={4} className="d-flex justify-content-center mb-4">
        <Card className="shadow-sm text-center" style={{ width: "22rem" }}>
          <Card.Body>
            <CgCommunity className="fs-1 mb-3 text-primary" />
            <Card.Title className="fw-bold">COMMUNITY PARTNERS</Card.Title>
            <Card.Text>
              This model differs from other lenders by reducing intermediary
              costs. The CSPs facilitate this.
            </Card.Text>
          </Card.Body>
        </Card>
      </Col>

      {/* Card 2 */}
      <Col md={6} lg={4} className="d-flex justify-content-center mb-4">
        <Card className="shadow-sm text-center border-warning" style={{ width: "22rem" }}>
          <Card.Body>
            <PiCircleHalfLight className="fs-1 mb-3 text-warning" />
            <Card.Title className="fw-bold">
              FULL TRANSPARENCY ON FUNDS USE
            </Card.Title>
            <Card.Text>
              Fixed CSP Financial Support: The expense Contribution to CSP's is
              transparent and fixed.
            </Card.Text>
          </Card.Body>
        </Card>
      </Col>

      {/* Card 3 */}
      <Col md={6} lg={4} className="d-flex justify-content-center mb-4">
        <Card className="shadow-sm text-center" style={{ width: "22rem" }}>
          <Card.Body>
            <FaCircleDollarToSlot className="fs-1 mb-3 text-success" />
            <Card.Title className="fw-bold">0% INTEREST RATES</Card.Title>
            <Card.Text>
              0% interest rates, with repayment of funds back into the core
              system, enable the core account to continue to grow.
            </Card.Text>
          </Card.Body>
        </Card>
      </Col>

      {/* Card 4 */}
      <Col md={6} lg={4} className="d-flex justify-content-center mb-4">
        <Card className="shadow-sm text-center" style={{ width: "22rem" }}>
          <Card.Body>
            <FaBitcoin className="fs-1 mb-3 text-dark" />
            <Card.Title className="fw-bold">
              BITCOIN AND LIGHTNING NETWORK
            </Card.Title>
            <Card.Text>
              These help users send value from their mobile phone and help you
              minimise or eliminate intermediary costs.
            </Card.Text>
          </Card.Body>
        </Card>
      </Col>

      {/* Card 5 */}
      <Col md={6} lg={4} className="d-flex justify-content-center mb-4">
        <Card className="shadow-sm text-center border-warning" style={{ width: "22rem" }}>
          <Card.Body>
            <BsCurrencyBitcoin className="fs-1 mb-3 text-warning" />
            <Card.Title className="fw-bold">
              BITCOIN FRIENDLY COMMUNITIES
            </Card.Title>
            <Card.Text>
              This service is designed and intended to facilitate building and
              growing small businesses in Bitcoin circular economies. Donations
              are long term investments into these communities.
            </Card.Text>
          </Card.Body>
        </Card>
      </Col>

      {/* Card 6 */}
      <Col md={6} lg={4} className="d-flex justify-content-center mb-4">
        <Card className="shadow-sm text-center" style={{ width: "22rem" }}>
          <Card.Body>
            <MdOutlineSocialDistance className="fs-1 mb-3 text-secondary" />
            <Card.Title className="fw-bold">
              STANDARDISATION AND CLEAR CAP
            </Card.Title>
            <Card.Text>
              Standardisation and clear cap on what community partners get paid
              for being loan broker-partners. It’s like a global “Loan Franchise
              model” for accredited community groups.
            </Card.Text>
          </Card.Body>
        </Card>
      </Col>
    </Row>
  );
};

export default FeaturesCards;
